import { Span, Button, Icon, FlexBox, Typography } from '@vp/swan';
import dt from './node_modules-styled-components-dist-styled-components.browser.esm.js';

const TextCursorSpan = dt(Span)`
  cursor: text;
  font-weight: bold;
`;
const FlexButton = dt(Button)`
  display: flex !important;
`;
const AppliedCouponStyledIcon = dt(Icon)`
  background-color: var(--swan-sem-color-bg-standard) !important;
`;
const AppliedPromoComponent = dt(FlexBox)`
  background-color: var(--swan-sem-color-bg-promo-strong-paired);
  border-radius: var(--swan-sem-border-radius-standard);
  align-items: center;
  justify-content: center;
  padding: 4px 8px 4px 8px;
  color: var(--swan-sem-color-text-promo-strong-paired);
  gap: var(--swan-sem-space-2);
  flex-shrink: 0;  
  max-width: fit-content;
`;
const ExtendedAppliedCouponStyledIcon = dt(
  AppliedCouponStyledIcon
)`
  pointer-events: none;
`;
const ClickableStyledIcon = dt(Icon)`
  pointer-events: none;
`;
const CharacterRestrictedEllipsedTypography = dt(
  Typography
)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 28ch;
`;
const WordBreakAllTypography = dt(FlexBox)` 
  flex-wrap: wrap;
  align-items: center;
  gap: var(--swan-sem-space-2);
`;
const LineRestrictedEllipsedTypography = dt(
  Typography
)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
const AppliedStatePromoBar = dt(FlexBox).attrs({
  fontWeight: "bold",
  fontSize: "small",
  px: 0,
  py: 0,
  style: { minHeight: 60 },
  alignItems: "flex-start",
  justifyContent: "center",
  gap: "2"
})`
  flex-direction: column !important;
  min-height: fit-content !important;
  width: fit-content;
  color: var(--swan-sem-color-text-standard);
  margin-top: var(--swan-sem-space-3);
  margin-bottom: var(--swan-sem-space-3);
  background-color: var(--sem-color-bg-none); // No background color for applied state
  border-radius: none; // No border radius for applied state
`;
const PromoBar = dt(FlexBox).attrs({
  fontWeight: "bold",
  fontSize: "small",
  px: 3,
  py: 2,
  style: { minHeight: 60 },
  alignItems: "flex-start",
  justifyContent: "center",
  gap: "2"
})`
  flex-direction: column !important;
  min-height: fit-content !important;
  width: fit-content;
  color: var(--swan-sem-color-text-standard);
  margin-top: var(--swan-sem-space-3);
  margin-bottom: var(--swan-sem-space-3);
  border-radius: var(--swan-sem-border-radius-standard);
  background-color: var(--swan-sem-color-bg-promo);
`;

export { AppliedCouponStyledIcon, AppliedPromoComponent, AppliedStatePromoBar, CharacterRestrictedEllipsedTypography, ClickableStyledIcon, ExtendedAppliedCouponStyledIcon, FlexButton, LineRestrictedEllipsedTypography, PromoBar, TextCursorSpan, WordBreakAllTypography };
//# sourceMappingURL=src-styledComponents-couponComponent.styles.js.map
